// Leads GraphQL queries

import { gql } from "@apollo/client"

export const GET_LEADS = gql`
  query GetLeads($fresh: Boolean) {
    getLeads(fresh: $fresh) {
      id
      opportunityID
      businessAccount
      status
      stage
      subject
      amount
      estimatedCloseDate
      currencyID
      reason
      ownerEmployeeName
    }
  }
`

export const GET_LEADS_ARCHIVE = gql`
  query GetLeadsArchive($fresh: Boolean) {
    getLeadsArchive(fresh: $fresh) {
      id
      opportunityID
      businessAccount
      status
      stage
      subject
      amount
      estimatedCloseDate
      currencyID
      reason
      ownerEmployeeName
    }
  }
`
